import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type QueuesAddonViewEntryPointComponent = EntryPointComponent<{}, {}, {}, {} | null>;

export const queuesAddonViewEntryPoint: EntryPoint<QueuesAddonViewEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<QueuesAddonViewEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-csm-queues-addon-view", jiraSpaEntry: "async-servicedesk-csm-queues-addon-view" */ './ExportedDefault.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
